/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail units meta reducer
 */

import { nullReducer } from '@zcode/reducers'
import type { UnitsMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import {
  CLEAR_UNITS,
  DONE_FETCHING_UNITS,
  ERROR_FETCHING_UNITS,
  RECEIVE_UNITS,
  START_FETCHING_UNITS,
} from '../constants/index'
import type { ActionTypes } from './types'

const metaReducer = combineReducers<UnitsMeta, ActionTypes>({
  currentListingIds: handleActions<UnitsMeta['currentListingIds'], ActionTypes>(
    {
      [CLEAR_UNITS]: () => [],
      [RECEIVE_UNITS]: (state, { payload: { listingId } }) =>
        listingId ? state.concat(listingId) : state,
    },
    []
  ),
  error: handleActions<UnitsMeta['error'], ActionTypes>(
    {
      [ERROR_FETCHING_UNITS]: (state, { payload }) => payload?.error || state,
      [CLEAR_UNITS]: nullReducer,
      [START_FETCHING_UNITS]: nullReducer,
    },
    null
  ),
  fetchingListingIds: handleActions<UnitsMeta['fetchingListingIds'], ActionTypes>(
    {
      [START_FETCHING_UNITS]: (state, { payload: { listingId } }) =>
        listingId ? state.concat(listingId) : state,
      [CLEAR_UNITS]: () => [],
      [DONE_FETCHING_UNITS]: (state, { payload: { listingId } }) =>
        state.filter((other) => other !== listingId),
    },
    []
  ),
})

export default metaReducer
